import React from 'react';
import PersonalizationText from '../PersonalizationText';
import PersonalizationOption from '../PersonalizationOption';
import { UX2 } from '@wsb/guac-widget-core';
import PropTypes from 'prop-types';

const Personalizations = props => {
  const {
    onChange,
    orderTypes,
    product,
    personalizationMap,
    selectedPersonalizations,
    requiredFieldsBlank,
    personalizationErrors,
    invalidPersonalizationIds
  } = props;
  const { Block } = UX2.Element;

  if (!product || !product.product_option_order) {
    return null;
  }

  const listItems = orderTypes.map((orderType, index) => {
    const personalization = personalizationMap[orderType.reference_id];
    const invalid = invalidPersonalizationIds.indexOf(orderType.reference_id + '') !== -1;
    const labelError = Boolean(
      selectedPersonalizations.hasOwnProperty(orderType.reference_id) &&
        invalid &&
        requiredFieldsBlank
    );

    if (personalization.kind === 'text') {
      const error = personalizationErrors.find(err => err.name === personalization.name);
      const errorMessage = error ? error.error : null;

      return (
        <PersonalizationText
          key={ 'personalization_input_' + index }
          { ...personalization }
          labelError={ labelError }
          errorMessage={ errorMessage }
          onChange={ onChange }
        />
      );
    }

    return (
      <PersonalizationOption
        key={ 'personalization_input_' + index }
        { ...personalization }
        labelError={ labelError }
        onChange={ onChange }
      />
    );
  });

  return <Block children={ listItems } />;
};

Personalizations.propTypes = {
  onChange: PropTypes.func,
  orderTypes: PropTypes.array,
  product: PropTypes.object,
  personalizationMap: PropTypes.object,
  selectedPersonalizations: PropTypes.any,
  requiredFieldsBlank: PropTypes.bool,
  personalizationErrors: PropTypes.array,
  invalidPersonalizationIds: PropTypes.array
};

export default Personalizations;
